import {Injectable} from '@angular/core';
import {Timestamp}                                                       from '@angular/fire/firestore';
import {CrudPathDict, MoodMeterBuilder, MoodRecordLogIntf, MoodTermType} from '@djsharkk/logr-types';
import {DataFirebaseBase}                                                from './data-firebase.base';

@Injectable({
				providedIn: 'root'
			})
export class DataMoodService extends DataFirebaseBase<MoodRecordLogIntf> {
	protected override paths: CrudPathDict = {
		log: 'mood_records_log',
		sum: undefined
	};


	moodMeter = MoodMeterBuilder();

	buildMoodRecord(t: MoodTermType): MoodRecordLogIntf {
		return {
			...this.moodMeter.obj[t].point,
			timestamp: Timestamp.now()
		};
	}


}
